/* import __COLOCATED_TEMPLATE__ from './prism-form-info-tooltip.hbs'; */
import { equal } from '@ember/object/computed';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { next } from '@ember/runloop';
import { deprecate } from '@ember/debug';

/**
 * Renders a help icon or link which toggles a tooltip. Tooltip content is provided via
 * a `text` param or block.
 *
 * ```hbs
 * {{prism-form-info-tooltip text="A tooltip!"}}
 *
 * {{#prism-form-info-tooltip}}
 *   <p>A tooltip!</p>
 * {{/prism-form-info-tooltip}}
 * ```
 *
 * @class PrismFormInfoTooltip
 */
export default Component.extend({
  classNames: ['prism-form-info-tooltip'],
  /**
   * String to display within the rendered tooltip.
   *
   * @argument text
   * @type {String}
   */
  text: null,
  /**
   * Class string to apply to the selected state tooltip icon.
   *
   * @argument iconSelectedClass
   * @type {String}
   */
  iconSelectedClass: '',
  /**
   * Determines the position of the tooltip. Can be `left` or `right`.
   *
   * @argument tooltipPosition
   * @type {String}
   */
  tooltipPosition: 'left',
  /**
   * Text to act as the trigger for the tooltip instead of an icon.
   *
   * @argument linkText
   * @type {String}
   */
  linkText: null,
  /**
   * Class string to apply to the link text
   *
   * @argument linkTextClass
   * @type {String}
   */
  linkTextClass: null,
  /**
   * Class string to apply to the selected state link text.
   *
   * @argument linkTextSelectedClass
   * @type {String}
   */
  linkTextSelectedClass: null,
  showTooltip: false,
  isLeft: equal('tooltipPosition', 'left'),
  tooltipBubbleClasses: computed('tooltipPosition', function () {
    const classes = ['prism-form-info-tooltip__bubble', `prism-form-info-tooltip__bubble--${this.tooltipPosition}`];
    return classes.join(' ');
  }),
  show() {
    next(() => {
      this.set('showTooltip', true);
    });
  },
  hide() {
    if (this.isDestroyed || this.isDestroying) {
      return;
    }
    this.set('showTooltip', false);
  },
  init(args) {
    // `deprecate` will show message if boolean arg is falsey.
    // If link text exists, we want to show the deprecation message.
    // Hence `!args.linkText`
    deprecate('Using prism-form-info-tooltip for a text link pop up is deprecated. Please convert this to use prism-text-tooltip.', !args.linkText, {
      id: 'prism-form-info-tooltip-link-text',
      until: '2.0.0',
      for: '@square/ember-prism',
      since: '1.28.2'
    });
    this._super(args);
  }
});